<template>
    <modal
      :title="
        pricePackage.deviceManagementPackageNumber
          ? 'Edit Package'
          : 'Add New Package'
      "
      ref="modifyPriceModal"
      size="modal-md"
      @save="savePricePackage()"
    >
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> Description </label>
          <input
            disabled
            type="text"
            class="form-control"
            v-model="pricePackage.description"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> Label </label>
          <input
            type="text"
            class="form-control"
            v-model="pricePackage.label"
          />
        </div>
      </div>
      <div class="row">
        <div
          class="form-group col-md-10"
          v-if="pricePackage.deviceManagementPackageNumber"
        >
          <label class="control-label"> Expired </label>
          <v-select :options="[true, false]" v-model="expired"></v-select>
        </div>
      </div>
    </modal>
  </template>
  
<script>
  import Modal from "@/components/GeneralComponents/Modal";
  export default {
    props: {
      pricePackage: {
        type: Object,
        required: true,
      },
    },
    computed: {
      expired: {
        get() {
          return this.pricePackage.expired.toString();
        },
        set(expired) {
          this.pricePackage.expired = expired;
        },
      },
    },
    components: {
      Modal,
    },
    methods: {
      open() {
        this.$refs.modifyPriceModal.open();
      },
      getLabel({ name }) {
        return name;
      },
      savePricePackage() {
        this.$refs.modifyPriceModal.isLoading();
        if (this.pricePackage.deviceManagementPackageNumber) {
            this.showSuccess("Successfully Edited Package");
            this.$emit("packageEdited", this.pricePackage);
        } else {
            this.showSuccess("Successfully Added Package");
            this.$emit("packageAdded", this.pricePackage);
        }
        this.$refs.modifyPriceModal.close();
        this.$refs.modifyPriceModal.isLoading();
      },
    },
  };
</script>

<style>
</style>
  